import React, { useEffect, useState } from "react";
import AuthUserContext from "./authContext";
import { withFirebase } from "../Firebase";
import { clearAuthToken } from "../../utils/api";

const withAuthentication = (Component) => {
  const WithAuthentication = (props) => {
    const [authUser, setAuthUser] = useState(undefined);

    useEffect(() => {
      if (typeof window === "undefined") {
        return;
      }
      try {
        const stored = localStorage.getItem("authUser");
        if (stored) {
          setAuthUser(JSON.parse(stored));
        }
      } catch (e) {
      }
    }, []);

    useEffect(() => {
      if (!props.firebase) {
        return;
      }
      const unsubscribe = props.firebase.onAuthUserListener(
        (user) => {
          if (typeof window !== "undefined") {
            localStorage.setItem("authUser", JSON.stringify(user));
          }
          setAuthUser(user);
        },
        () => {
          clearAuthToken();
          if (typeof window !== "undefined") {
            localStorage.removeItem("authUser");
          }
          setAuthUser(null);
        }
      );

      return () => {
        unsubscribe();
      };
    }, [props.firebase]);

    return (
      <AuthUserContext.Provider value={authUser}>
        <Component {...props} user={authUser} />
      </AuthUserContext.Provider>
    );
  };

  return withFirebase(WithAuthentication);
};

export default withAuthentication;
